import { render, staticRenderFns } from "./LoggedUserMenu.vue?vue&type=template&id=5ba95b05"
import script from "./LoggedUserMenu.vue?vue&type=script&lang=js"
export * from "./LoggedUserMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports